import { operatorTypes } from './operators.types';

const INITIAL_STATE = {
  operators: {
    loading: false,
    data: null,
  },
  weeklyChosenOperator: {
    loading: false,
    data: {},
  },
  currentOperator: {},
  toEditedOperator: {},
  operatorReports: {},
  sortedOperators: {
    loading: false,
    data: [],
    metrics : {}
  },
};

const operatorReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case operatorTypes.SET_OPERATORS:
      return {
        ...state,
        operators: {
          loading: false,
          data: action.payload,
        },
      };
    case operatorTypes.LOADING_WEEKLY_CHOSEN_OPERATOR:
      return {
        ...state,
        weeklyChosenOperator: {
          ...state.weeklyChosenOperator,
          loading: true,
        },
      };
    case operatorTypes.SET_WEEKLY_CHOSEN_OPERATOR:
      return {
        ...state,
        weeklyChosenOperator: {
          loading: false,
          data:
            action.payload && Object.keys(action.payload).length > 0
              ? action.payload
              : null,
        },
      };
    case operatorTypes.LOADING_OPERATORS:
      return {
        ...state,
        operators: {
          ...state.operators,
          loading: true,
        },
      };
    case operatorTypes.UPDATE_REMOVED_OPERATOR:
      return {
        ...state,
        operators: {
          ...state.operators,
          data: state.operators.data.filter(
            (operator) => operator.id !== action.payload
          ),
        },
      };
    case operatorTypes.SET_CURRENT_OPERATOR:
      return {
        ...state,
        currentOperator: action.payload.isWeeklyChosen
          ? state.weeklyChosenOperator.data
          : state.operators.data.filter(
              (operator) => operator.id === action.payload.operatorId
            )[0],
      };
    case operatorTypes.RESET_CURRENT_OPERATOR:
      return {
        ...state,
        currentOperator: {},
      };
    case operatorTypes.SET_EDITED_OPERATOR:
      return {
        ...state,
        operators: {
          ...state.operators,
          data: state.operators.data.map((operator) =>
            operator.id === action.payload.id ? action.payload : operator
          ),
        },
      };
    case operatorTypes.SAVE_TO_EDITED_OPERATOR:
      return {
        ...state,
        toEditedOperator: action.payload,
      };
    case operatorTypes.SET_OPERATOR_REPORTS:
      return {
        ...state,
        operatorReports: action.payload,
      };
    case operatorTypes.SET_OPERATORS_TABLE_DATA:
      return {
        ...state,
        operatorsTableData: action.payload,
      };
    case operatorTypes.SET_SORTED_OPERATORS_LIST:
      return {
        ...state,
        sortedOperators : {
          loading : false , 
          data: action.payload.list,
          metrics : action.payload.metrics
        }
      };
    case operatorTypes.LOADING_SORTED_OPERATORS_LIST_START:
      return {
        ...state,
        sortedOperators : {
          ...state.sortedOperators,
          loading : action.payload , 
        }
      };

    default:
      return state;
  }
};

export default operatorReducer;
